module.exports = __webpack_public_path__ + "static/media/adriana.010fdd21.jpg";